import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  historyContainer: {
    display: "flex",
    flexGrow: 1,
    height: "100%",
    minHeight: "2em",
    width: "100%",
  },

  modal: {
    overflow: "hidden !important",
    width: "676px !important",
    "& #modalHeader": {
      padding: "24px 24px 0 24px !important",
      "& .MuiIconButton-root": {
        right: "-12px !important",
      },
    },
    "& #modalBody": {
      flexDirection: "column",
      flexWrap: "nowrap",
      height: "100%",
      margin: "unset !important",
      maxHeight: "640px",
      overflow: "hidden",
      padding: "0 !important",
    },
  },
}));

export default styles;
